import React from "react";
import "./Growth_Opportunities.css";

function Growth_Opportunities() {
  return (
    <>
      <section className="Growth_Opportunities_holder">
        <div className="container">
          <div className="Growth_Opportunities">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="content-holder">
                  <div>
                    <div className="heading-holder">
                      <h3>
                        Growth <br />
                        <span>Opportunities</span>
                      </h3>
                    </div>
                    <div className="text-holder">
                      <p>
                        At ReachOut Media Tech, we believe in nurturing talent.
                        We offer professional development opportunities,
                        mentorship, and the chance to work on exciting projects
                        that challenge and inspire you.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-7 col-12">
                <div className="Growth_Opportunities_img_holder">
                  <img
                    className="Growth_Opportunities_img"
                    src={
                      process.env.PUBLIC_URL +
                      "/Assets/Images/Career/Growth_Opportunities/man_investments.png"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Growth_Opportunities;
